import React from "react";
import { Eye, OctagonX } from "lucide-react";
import IconAction from "../../../components/IconAction";

// Row actions of the Cases list. Stop is shown to a Super Admin on OPEN cases. `busy` = { id, action } in flight.
export default function InstanceRowActions({ row, canManage, busy, onView, onStop }) {
  const anyBusy = busy?.id === row.id;
  return (
    <div className="flex items-center gap-1">
      <IconAction label="View" icon={Eye} onClick={() => onView(row)} busy={anyBusy && busy.action === "view"} disabled={anyBusy} />
      {canManage && row.status === "OPEN" && <IconAction label="Stop this case" icon={OctagonX} tone="danger" onClick={() => onStop(row)} disabled={anyBusy} />}
    </div>
  );
}
